import React from 'react'
import { browserHistory } from 'react-router'
import { renderMoney, isPC } from '../../utils'
import { WKVisible } from '../../components/wk'


class ScheduleItem extends React.Component {
    onClickActionBtn (id) {
        if (id) {
            location.assign(`/schedule/${id}`)
        }
    }
    // renderLabel (item) {
    //     const tpls = []
    //     if (item.schedule.bonus_flag) {
    //         tpls.push(<div className={`label ${item.schedule.process === 'close' ? 'is-grey' : ''}`}>返奖金</div>)
    //     }
    //     if (item.schedule.process === 'close') {
    //         tpls.push(<div className="label is-grey">已结束</div>)
    //         return tpls
    //     }
    //     if (!item.schedule.access) {
    //         tpls.push(<div className="label is-grey">未参与</div>)
    //         return tpls
    //     }
    //     if (item.schedule.process === 'starting') {
            
    //     }
    // }
    render() {
        const item = this.props.item
        let isJoin
        if (this.props.isJoin) {
            isJoin = true
        } else {
            isJoin = item && item.access && item.access.participate
        }
        return (
            <div 
                className={`schdule-item wk-border-line-after ${isPC() ? 'is-pc' : ''}`}
                onClick={e => this.onClickActionBtn(this.props.id)}
            >
                <div className="cover" style={{ backgroundImage: `url(${this.props.banner})` }}>
                </div>
                <div className="content">
                    <div className="title">{this.props.title}</div>
                    {
                        !this.props.isHideLabel && (
                            <div className="labels">
                                {
                                    item.schedule.bonus_flag && <div className={`label ${item.schedule.process === 'close' ? 'is-grey' : ''}`}>返奖金</div>
                                }
                                {
                                    item.schedule.process === 'starting' && isJoin && item.is_signin_today && (
                                        <div className="label is-grey">已打卡</div>
                                    )
                                }
                                {
                                    item.schedule.process === 'starting' && isJoin && !item.is_signin_today && (
                                        <div className="label is-green">未打卡</div>
                                    )
                                }
                                { (item.schedule.process === 'not_start' && isJoin) && <div className="label is-grey">已参与</div> }
                                { (!isJoin && item.schedule.process !== 'close') && <div className="label is-grey">未参与</div> }
                                { item.schedule.process === 'close' && <div className="label is-grey">已结束</div> }
                            </div>
                        )
                    }
                    <div className="desc">
                        <WKVisible create={this.props.signinCount}>
                            <div className="days">已打卡<span className='green'>{this.props.signinCount}</span>天</div>
                        </WKVisible>
                        <div className={`count ${this.props.signinCount ? '' : 'no-padding'}`}>
                            {this.props.joinCount}人参与
                        </div>
                    </div>
                    <div className="time">
                        {this.props.time}
                    </div>
                </div>
                {
                    !this.props.isHideBtn && item.schedule.signup_fee > 0 && (
                        <div className="price">
                            ￥{renderMoney(item.schedule.signup_fee)}
                        </div>
                    )
                }
            </div>
        )
    }
}

export default ScheduleItem


// WEBPACK FOOTER //
// ./src/pages/schedule/ScheduleItem.js